import { render } from "./App.vue?vue&type=template&id=3afde7dc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3afde7dc&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__